module.exports = __webpack_public_path__ + "img/2_47.765aa8d5.png";